import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Chart, ChartConfiguration, ChartItem, registerables } from 'chart.js';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import QRCode from 'qrcode';
import * as tf from '@tensorflow/tfjs';
import * as faceapi from 'face-api.js';
import QrScanner from 'qr-scanner';
import { DomSanitizer } from '@angular/platform-browser';
import { QueryService } from './query.service';
import * as bank from './bank'
@Injectable({
  providedIn: 'root'
})
export class SharedService {
  public standalone = JSON.parse(new URLSearchParams(window.location.search).get("standalone") || 'false');
  public shareObject: any = {};
  public env = environment;
  public production = environment.production;
  public messageSubject = new BehaviorSubject('');
  public Message = this.messageSubject.asObservable();
  public toastSubject = new BehaviorSubject({});
  public Toast = this.toastSubject.asObservable();
  public alertSubject = new BehaviorSubject(null);
  public Alert = this.alertSubject.asObservable();
  public confirmSubject = new BehaviorSubject(null);
  public Confirm = this.confirmSubject.asObservable();
  public onConfirm = new BehaviorSubject<boolean>(false);
  public userTypingSubject = new Subject<string>();
  private manifestLink: HTMLLinkElement;
  private dbName = 'AqbCacheDB';
  private dbVersion = 1;
  private storeName = 'apiCache';
  private db: IDBDatabase | null = null;
  modals: any = {};
  query: QueryService = new QueryService();
  constructor(
    private http: HttpClient,
    private router: Router,
    private location: Location,
    private translate: TranslateService,
    private sanitizer: DomSanitizer,
    private queryService: QueryService
  ) {

    this.shareObject.filter = {
      user: {
        $or: [
          { 'profile.workEnd': { $exists: false } },
          { 'profile.workEnd': { $in: [null, ""] } },
          {
            $and: [
              { 'profile.workEnd': { $exists: true } },
              { 'profile.workEnd': { $gt: new Date() } }
            ]
          }
        ],
        roles: { $nin: ['admin.system'] }
      },
    };
    this.shareObject.select = {
      users: {
        uri: 'users/list',
        data: {
          select: {
            email: 1,
            createdAt: 1,
            profile: { employeeId: 1, name: 1, phone: 1, employeeGroup: 1, createdBy: 1 },
            'profile.createdBy': { email: 1, profile: { name: 1 } },
            'profile.employeeGroup': { name: 1 },
          },
          filter: this.shareObject.filter.user || {},
        }
      },
      group: { uri: 'employee_group/list', data: { select: { name: 1, user: { profile: { name: 1 } } } } },
    };
    this.shareObject.bankData = bank.bankList;
    // Cho phép admin.system xem tất cả người dùng
    if (this.user && this.user?.roles && (this.user.roles.includes('admin.system'))) {
      delete this.shareObject.filter.user.roles;
    }
    Chart.register(...registerables);
    this.manifestLink = document.querySelector('link[rel="manifest"]')!;
    let subHost: any = window.location.hostname.split('.')[0];
    if (!['localhost', 'staging', 'www', 'aqbakery', 'aqb', '192', '127'].includes(subHost)) {
      this.standalone = true;
      // this.setManifest(`/assets/manifest-${subHost}.webmanifest`);
    }
    // this.loadModels();
    this.translateKeyword();
    this.initIndexedDB().then(() => {
      this.startCacheCleanup();
    }).catch(error => {
      console.error('IndexedDB initialization failed:', error);
    });
    // lấy vị trí hiện tại của user rồi lưu vào localstorage
    setTimeout(() => {
      this.getUserLocation();
    }, 5000);
  }
  loginAsUser(id: any) {
    this.callApi('/admin/user_token', { id }).subscribe({
      next: (res: any) => {
        if (res && res.success) {
          // backup old user
          let oldToken = localStorage.getItem('token') || '';
          let oldUser = localStorage.getItem('user') || '{}';
          localStorage.setItem('oldUser', oldUser);
          localStorage.setItem('oldToken', oldToken);
          localStorage.setItem('user', JSON.stringify(res.data.user));
          localStorage.setItem('token', JSON.stringify(res.data.token));
          this.router.navigate(['/']);
        }
      }, error: (error) => {
        this.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('toast_cant_get_data'),
          type: 'danger',
        });
      }
    });
  }
  getUserLocation() {
    return new Promise((resolve) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          this.shareObject.userLocation = position.coords;
          resolve(true);
        }, (error) => {
          this.confirm({
            message: this.translate.instant('please_enable_location'),
            skipCancel: true,
            type: 'primary'
          }).then(() => {
            this.getUserLocation();
          });
        }
        );
      } else {
        this.confirm({
          title: this.translate.instant('error'),
          message: this.translate.instant('geolocation_not_supported'),
          type: 'danger',
        });
      }
    });
  }
  static getUser() {
    return JSON.parse(localStorage.getItem('user') || '{}');
  }
  bankHashGenerator(data: any = { bankId: "", bankBin: "", amount: "", note: "" }) {
    return bank.bankHashGenerator(data);
  }
  isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }
  isAdmin() {
    let user = SharedService.getUser();
    if (user && user.roles && (user.roles.includes('admin.index') || user.roles.includes('admin.super'))) {
      return true;
    }
    return false;
  }
  setManifest(manifestUrl: string): void {
    this.manifestLink.setAttribute('href', manifestUrl);
  }
  onUserTyping(event: any) {
    this.userTypingSubject.next(event.target.value);
  }
  async pwaInstall(manifestUrl: string = '') {
    let oldManifestUrl = this.manifestLink.getAttribute('href');
    if (oldManifestUrl && oldManifestUrl != manifestUrl) {
      this.manifestLink.setAttribute('href', manifestUrl);
    }
    let manifestInfo = await fetch(manifestUrl).then((res) => res.json());
    let deferredPrompt: any;
    window.addEventListener('beforeinstallprompt', (e: any) => {
      e.preventDefault();
      deferredPrompt = e;
      this.toast({
        title: this.translate.instant('install_app'),
        message: this.translate.instant('install_app_message'),
        type: 'info',
      });
    });
    this.toastSubject.subscribe((data: any) => {
      if (data && data.type == 'info' && deferredPrompt) {
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then((choiceResult: any) => {
          if (choiceResult.outcome === 'accepted') {
            this.toast({
              title: this.translate.instant('app_installed'),
              message: `${manifestInfo.name} ${this.translate.instant('app_installed_message')}`,
              type: 'success',
            });
            if (oldManifestUrl && oldManifestUrl != manifestUrl) {
              this.manifestLink.setAttribute('href', manifestUrl);
            }
            location.href = manifestInfo.start_url;
          } else {
            this.toast({
              title: this.translate.instant('install_app_failed'),
              message: this.translate.instant('install_app_failed_message'),
              type: 'warning',
            });
          }
          deferredPrompt = null;
        });
      }
    });

  }
  confirm(e: any) {
    this.confirmSubject.next(e);
    return new Promise((resolve) => {
      this.onConfirm = new BehaviorSubject<boolean>(false);
      this.onConfirm.subscribe((data: any) => {
        if (data) {
          resolve(data);
        }
      });
    });
  }
  alert(e: any) {
    this.alertSubject.next(e);
  }
  toast(e: any) {
    if (e && e.type && e.type == 'error') {
      e.type = 'danger';
    }
    this.toastSubject.next(e);
  }
  login(email: string, password: string, staySignedIn: boolean): Observable<any> {
    let request = this.http.post(`${this.env.apiUrl}/components/auth/login`, { email, password, staySignedIn });
    return request.pipe(
      // Nếu lỗi login
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.toast({
            title: this.translate.instant('unauthorized'),
            message: this.translate.instant('unauthorized_message'),
            type: 'danger',
          });
          localStorage.removeItem('user');
          localStorage.removeItem('token');
        } else if (error.status === 400) {
          // Handle bad request error
          this.toast({
            title: this.translate.instant('bad_request'),
            // message: error.error?.message || this.translate.instant('invalid_request_message'),
            message: 'Lỗi request #4',
            type: 'danger',
          });
        } else {
          // Handle other errors
          this.toast({
            title: this.translate.instant('error'),
            // message: error.message || this.translate.instant('unexpected_error_message'),
            message: `Lỗi request #3 ${JSON.stringify(error)}`,
            type: 'danger',
            delay: 10000
          });
        }
        return throwError(() => error);
      }),
      // Nếu login thành công
      tap((response: any) => {
        if (response && response.token) {
          localStorage.setItem('user', JSON.stringify(response.user));
          localStorage.setItem('token', JSON.stringify(response.token));
          this.router.navigate(['user', 'profile']);
        } else {
          this.toast({
            title: this.translate.instant('login_failed'),
            message: this.translate.instant('login_failed_message'),
            type: 'danger',
          });
        }
      }),
    );

  }
  profile(): Observable<any> {
    return this.callApi('/users/profile', {}, { cache: true, cacheTime: 1200 }); // Cache for 10 minutes
  }
  mapId(source: any, id: string, key: string = 'id'): any {
    if (source) {
      if (Array.isArray(source)) {
        return source.find((e: any) => e[key] === id);
      }
      if (source.data && Array.isArray(source.data)) {
        return source.data.find((e: any) => e[key] === id);
      }
    }
    return null;
  }
  openSignMedia(id: any) {
    this.callApi(`/media/signature`, { id }, { cache: false, cacheTime: 1200 }).subscribe({
      next: (res: any) => {
        if (res && res.success) {
          let mediaUrl = `${this.env.apiUrl}/components/media/download/${id}.file?access_token=${this.token}&signature=${res.data.signature}`;
          (window as any).open(mediaUrl, '_blank');
        }
      },
      error: (error) => {
        this.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('toast_cant_get_data'),
          type: 'danger',
        });
      }
    });
  }
  getBatch(source: any): Observable<any> {
    return new Observable((observer) => {
      source.isLoading = true;
      source.filterBox = false;

      let url = `/batch`;
      let urlQuery = new URLSearchParams();
      if (source.bulkRequest) {
        urlQuery.append('bulk', 'true');
      }
      if (source.selectAll) {
        urlQuery.append('selectall', 'true');
      }
      this.callApi(`${url}?${urlQuery.toString()}`, source.payload, { cache: false, cacheTime: 1200 }).subscribe({
        next: (res: any) => {
          source.isLoading = false;
          if (res && res.success) {
            observer.next(res);
          } else {
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('toast_cant_get_data'),
              type: 'danger',
            });
            observer.error(res);
          }
        },
        error: (error) => {
          source.isLoading = false;
          this.toast({
            title: this.translate.instant('error'),
            message: this.translate.instant('toast_cant_get_data'),
            type: 'danger',
          });
          observer.error(error);
        },
        complete: () => {
          observer.complete();
        }
      });
    });
  }
  getItems(source: any): Observable<any> {
    console.log(source);
    return new Observable((observer) => {
      source.isLoading = true;
      source.filterBox = false;
      console.log(source.filters);
      if (source.filters && source.filters.length > 0) {
        source.options.filter = { $and: source.filters.map((e: any) => e.filter) || [] };
      } else {
        delete source.options.filter;
      }
      this.callApi(`${source.path}?selectall=true`, source.options, { cache: false, cacheTime: 1200 }).subscribe({
        next: (res: any) => {
          source.isLoading = false;
          if (res && res.success) {
            observer.next(res);
          } else {
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('toast_cant_get_data'),
              type: 'danger',
            });
            observer.error(res);
          }
        },
        error: (error) => {
          source.isLoading = false;
          this.toast({
            title: this.translate.instant('error'),
            message: this.translate.instant('toast_cant_get_data'),
            type: 'danger',
          });
          observer.error(error);
        },
        complete: () => {
          observer.complete();
        }
      });
    });
  }
  getItem(source: any): Observable<any> {
    return new Observable((observer) => {
      source.isLoading = true;
      this.callApi(`${source.component}/get`, { id: source.id }, { cache: false, cacheTime: 1200 }).subscribe({
        next: (res: any) => {
          source.isLoading = false;
          if (res && res.success) {
            observer.next(res);
          } else {
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('toast_cant_get_data'),
              type: 'danger',
            });
            observer.error(res);
          }
        },
        error: (error) => {
          source.isLoading = false;
          this.toast({
            title: this.translate.instant('error'),
            message: this.translate.instant('toast_cant_get_data'),
            type: 'danger',
          });
          observer.error(error);
        },
        complete: () => {
          observer.complete();
        }
      });
    });
  }
  addItem(source: any): Observable<any> {
    return new Observable((observer) => {
      source.isLoading = true;
      this.callApi(`${source.component}/add`, source.payload).subscribe({
        next: (res: any) => {
          source.isLoading = false;
          if (res && res.success) {
            this.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('add_success'),
              type: 'success',
            });
            observer.next(res);
          } else {
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('add_failed'),
              type: 'warning',

            });
            observer.error(res);
          }
        },
        error: (error) => {
          source.isLoading = false;
          this.toast({
            title: this.translate.instant('error'),
            message: this.translate.instant('add_failed'),
            type: 'danger',
          });
          observer.error(error);
        },
        complete: () => {
          observer.complete();
        }
      });
    });
  }
  request(source: any): Observable<any> {
    return new Observable((observer) => {
      source.isLoading = true;
      this.callApi(`${source.component}/_request`, source.payload).subscribe({
        next: (res: any) => {
          source.isLoading = false;
          if (res && res.success) {
            this.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('toast_created'),
              type: 'success',
            });
            observer.next(res);
          } else {
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('toast_create_failed'),
              type: 'warning',

            });

            observer.error(res);
          }
        },
        error: (error) => {
          source.isLoading = false;
          this.toast({
            title: this.translate.instant('error'),
            message: this.translate.instant('toast_create_failed'),

            type: 'danger',
          });
          observer.error(error);
        },
        complete: () => {
          observer.complete();
        }
      });
    });
  }
  addManyItem(source: any): Observable<any> {
    return new Observable((observer) => {
      source.isLoading = true;
      this.callApi(`${source.component}/add_many`, { data: source.payload }).subscribe({
        next: (res: any) => {
          source.isLoading = false;
          if (res && res.success) {
            this.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('add_success'),
              type: 'success',
            });
            observer.next(res);
          } else {
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('add_failed'),
              type: 'warning',
            });
            observer.error(res);
          }
        },
        error: (error) => {
          source.isLoading = false;
          this.toast({
            title: this.translate.instant('error'),
            message: this.translate.instant('add_failed'),
            type: 'danger',
          });
          observer.error(error);
        },
        complete: () => {
          observer.complete();
        }
      });
    });
  }
  updateManyItem(source: any): Observable<any> {
    return new Observable((observer) => {
      source.isLoading = true;
      this.callApi(`${source.component}/update_many`, { data: source.payload }).subscribe({
        next: (res: any) => {
          source.isLoading = false;
          if (res && res.success) {
            this.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('update_success'),
              type: 'success',
            });
            observer.next(res);
          } else {
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('update_failed'),
              type: 'warning',
            });
            observer.error(res);
          }
        },
        error: (error) => {
          source.isLoading = false;
          this.toast({
            title: this.translate.instant('error'),
            message: this.translate.instant('update_failed'),
            type: 'danger',
          });
          observer.error(error);
        },
        complete: () => {
          observer.complete();
        }
      });
    });
  }
  updateItem(source: any): Observable<any> {
    return new Observable((observer) => {
      source.isLoading = true;
      source.payload.id = source.payload.id ? source.payload.id : source.id; // Ensure the payload has the id for update
      this.callApi(`${source.component}/update`, source.payload).subscribe({
        next: (res: any) => {
          source.isLoading = false;
          if (res && res.success) {
            this.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('update_success'),
              type: 'success',
            });
            observer.next(res);
          } else {
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('update_failed'),
              type: 'warning',
            });
            observer.error(res);
          }
        },
        error: (error) => {
          source.isLoading = false;
          this.toast({
            title: this.translate.instant('error'),
            message: this.translate.instant('update_failed'),
            type: 'danger',
          });
          observer.error(error);
        },
        complete: () => {
          observer.complete();
        }
      });
    });
  }
  deleteSoftItem(source: any): Observable<any> {
    return new Observable((observer) => {
      const doDelete = () => {
        source.isLoading = true;
        this.callApi(`${source.component}/delete_soft_many`, { ids: source.ids }).subscribe({
          next: (res: any) => {
            source.isLoading = false;
            if (res && res.success) {
              this.toast({
                title: this.translate.instant('success'),
                message: this.translate.instant('delete_success'),
                type: 'success',
              });
              observer.next(res);
            } else {
              this.toast({
                title: this.translate.instant('error'),
                message: this.translate.instant('restore_failed'),
                type: 'warning',
              });
              observer.error(res);
            }
          },
          error: (error) => {
            source.isLoading = false;
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('delete_failed'),
              type: 'danger',
            });
            observer.error(error);
          },
          complete: () => {
            observer.complete();
          }
        });
      }

      this.confirm({
        title: this.translate.instant('confirm'),
        message: this.translate.instant('confirm_delete'),
      }).then((confirmed: any) => {
        if (confirmed) {
          doDelete();
        } else {
          observer.complete(); // hoặc observer.error nếu bạn muốn xử lý khác
        }
      });
    });
  }
  deleteItem(source: any): Observable<any> {
    return new Observable((observer) => {
      const doDelete = () => {
        source.isLoading = true;
        this.callApi(`${source.component}/delete_many`, { ids: source.ids }).subscribe({
          next: (res: any) => {
            source.isLoading = false;
            if (res && res.success) {
              this.toast({
                title: this.translate.instant('success'),
                message: this.translate.instant('delete_success'),
                type: 'success',
              });
              observer.next(res);
            } else {
              this.toast({
                title: this.translate.instant('error'),
                message: this.translate.instant('restore_failed'),
                type: 'warning',
              });
              observer.error(res);
            }
          },
          error: (error) => {
            source.isLoading = false;
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('delete_failed'),
              type: 'danger',
            });
            observer.error(error);
          },
          complete: () => {
            observer.complete();
          }
        });
      }

      this.confirm({
        title: this.translate.instant('confirm'),
        message: this.translate.instant('confirm_delete'),
      }).then((confirmed: any) => {
        if (confirmed) {
          doDelete();
        } else {
          observer.complete(); // hoặc observer.error nếu bạn muốn xử lý khác
        }
      });
    });
  }
  restoreItem(source: any): Observable<any> {
    return new Observable((observer) => {
      const doRestore = () => {
        source.isLoading = true;
        this.callApi(`${source.component}/restore_many`, { ids: source.ids }).subscribe({
          next: (res: any) => {
            source.isLoading = false;
            if (res && res.success) {
              this.toast({
                title: this.translate.instant('success'),
                message: this.translate.instant('restore_success'),
                type: 'success',
              });
              observer.next(res);
            } else {
              this.toast({
                title: this.translate.instant('error'),
                message: this.translate.instant('restore_failed'),
                type: 'warning',
              });
              observer.error(res);
            }
          },
          error: (error) => {
            source.isLoading = false;
            this.toast({
              title: this.translate.instant('error'),
              message: this.translate.instant('restore_failed'),
              type: 'danger',
            });
            observer.error(error);
          },
          complete: () => {
            observer.complete();
          }
        });
      }

      this.confirm({
        title: this.translate.instant('confirm'),
        message: this.translate.instant('confirm_restore'),
      }).then((confirmed: any) => {
        if (confirmed) {
          doRestore();
        } else {
          observer.complete(); // hoặc observer.error nếu bạn muốn xử lý khác
        }
      });
    });
  }
  formatLocalDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // tháng bắt đầu từ 0
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  patchTime(type: string) {
    let startDate = new Date();
    let endDate = new Date();
    if (type === 'week') {
      startDate.setDate(startDate.getDate() - startDate.getDay());
      endDate.setDate(endDate.getDate() - endDate.getDay() + 6);
    } else if (type === 'last_week') {
      startDate.setDate(startDate.getDate() - startDate.getDay() - 7);
      endDate.setDate(endDate.getDate() - endDate.getDay() - 1);
    } else if (type === 'month') {
      startDate.setDate(1);
      endDate.setMonth(endDate.getMonth() + 1);
      endDate.setDate(0);
    } else if (type === 'last_month') {
      const now = new Date();
      startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      endDate = new Date(now.getFullYear(), now.getMonth(), 0);
    }
    return { startDate, endDate };
  }
  createFilters_bak(sourceData: any) {
    let formValue = sourceData.filterForm.value;
    let config = sourceData.filter;
    let filters: any[] = [];
    Object.entries(formValue).forEach(([key, value]: [string, any]) => {
      if (!value || value === '') return;
      let field = config[key];
      if (!field) return;
      if (typeof value === 'string') {
        value = value.trim();
      }
      let displayValue = field.getValue ? field.getValue(value, sourceData) : value;
      let filter = field?.filter(value);
      let type = field?.type || null;
      let subType = field?.subType || null;
      filters.push({ key, value, displayValue, filter, type, subType });
    });

    // Remove duplicates
    return filters.filter((f: any, index: number, self: any) =>
      index === self.findIndex((t: any) => t.key === f.key && t.value === f.value)
    );

  }
  createFilters(sourceData: any) {
    let formValue = sourceData.filterForm.value;
    let config = sourceData.filter;
    let filters: any[] = [];
    Object.entries(formValue).forEach(([key, value]: [string, any]) => {
      if (!value || value === '') return;
      let field = config[key];
      if (!field) return;
      if (typeof value === 'string') {
        value = value.trim();
      }
      let displayValue = field.getValue ? field.getValue(value, sourceData) : value;
      let filter = field?.filter(value);
      let type = field?.type || null;
      let subType = field?.subType || null;
      filters.push({ key, value, displayValue, filter, type, subType });
    });
    // Remove duplicates
    sourceData.filters = filters.filter((f: any, index: number, self: any) =>
      index === self.findIndex((t: any) => t.key === f.key && t.value === f.value)
    );
    let payload: any = { items: sourceData.query };
    if (sourceData.filters.length > 0 && sourceData.query) {
      payload = this.buildPayloadFromFilters(sourceData);
    }
    return { filters, payload }

  }
  applyFilters(data: any[], filters: any[]) {
    return data.filter((item: any) =>
      filters.every((f: any) => f.filter(item))
    );
  }
  buildPayloadFromFilters(source: any) {
    const payload: any = {};
    let itemsFilter = { ...source.query.data.filter };
    const filterUser = source.filters.find((f: any) => f.key === source.key);
    const filterGroup = source.filters.find((f: any) => f.key === 'employeeGroup');
    const limit = source.filters.find((f: any) => f.key === 'limit');
    if (filterUser || filterGroup) {
      const userFilter: any = this.queryService._users;
      if (filterUser) {
        if (/^\d+$/.test(filterUser.value)) {
          userFilter.data.filter['profile.employeeId'] = filterUser.value;
        } else {
          userFilter.data.filter['profile.name'] = { $regex: filterUser.value, $options: 'i' };
        }
      }
      if (filterGroup) {
        userFilter.data.filter['profile.employeeGroup'] = filterGroup.value;
      }
      payload.users = userFilter;
      itemsFilter[source.key] = { $in: "users.data.$id" };
    }
    if (limit) {
      source.query.data.limit = limit.value;
    }
    const dateFilters = source.filters.filter((f: any) => f.type === 'date' && f.value);
    for (let f of dateFilters) {
      if (f?.subType === 'start' || f?.subType === 'end') {
        itemsFilter[f.key] = f.filter[f.key];
      }
    }
    payload.items = { ...source.query, data: { ...source.query.data, filter: itemsFilter } };
    return payload;
  }

  filterUser(source: any) {
    let payload: any = {};
    let filterEmployees = source.filters.find((f: any) => f.key === source.key);
    console.log('filterEmployees', filterEmployees);
    if (filterEmployees) {
      let userFilter: any = this.queryService._users;
      if (/^\d+$/.test(filterEmployees.value)) {
        userFilter.data.filter['profile.employeeId'] = filterEmployees.value;
      } else {
        userFilter.data.filter['profile.name'] = { $regex: filterEmployees.value, $options: 'i' };
      }
      payload.users = userFilter;
      payload.items = source.query;
      payload.items.data.filter[source.key] = { $in: "users.data.$id" };
      console.log('payload', payload);
    } else {
      payload.items = source.query;
    }
    return payload;
  }
  filterDate(source: any) {
    let payload: any = {};
    let filterDate = source.filters.filter((f: any) => f.type === 'date');
    if (filterDate && filterDate.length > 0) {
      let dateFilter: any = {};
      for (let f of filterDate) {
        if (f.value && f?.subType == 'start') {
          dateFilter[f.key] = f.filter[f.key];
        }
        if (f.value && f?.subType == 'end') {
          dateFilter[f.key] = f.filter[f.key];
        }
      }
      payload.items = source.query;
      payload.items.data.filter = { ...source.query.data.filter, ...dateFilter };
    } else {
      payload.items = source.query;
    }
    return payload;
  }
  // IndexedDB methods
  private async initIndexedDB(): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(this.dbName, this.dbVersion);

      request.onerror = () => {
        console.error('IndexedDB failed to open');
        reject(request.error);
      };

      request.onsuccess = () => {
        this.db = request.result;
        resolve();
      };

      request.onupgradeneeded = (event: any) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(this.storeName)) {
          const store = db.createObjectStore(this.storeName, { keyPath: 'key' });
          store.createIndex('expireTime', 'expireTime', { unique: false });
        }
      };
    });
  }

  private async ensureDB(): Promise<IDBDatabase> {
    if (!this.db) {
      await this.initIndexedDB();
    }
    return this.db!;
  }

  private generateCacheKey(path: string, payload: any): string {
    const baseKey = path.replace(/[^a-zA-Z0-9]/g, '_');
    if (payload) {
      let payloadStr = JSON.stringify(payload);
      let payloadHex = Array.from(payloadStr).map(c => c.charCodeAt(0).toString(16).padStart(2, '0')).join('');
      return `${baseKey}.${payloadHex}`;
    }
    return baseKey;
  }

  private async getCachedData(key: string): Promise<any> {
    try {
      const db = await this.ensureDB();
      const transaction = db.transaction([this.storeName], 'readonly');
      const store = transaction.objectStore(this.storeName);

      return new Promise((resolve, reject) => {
        const request = store.get(key);

        request.onsuccess = () => {
          const result = request.result;
          if (result) {
            // Kiểm tra expiry
            if (result.expireTime > Date.now()) {
              resolve(result.data);
            } else {
              // Dữ liệu đã hết hạn, xóa khỏi cache
              this.removeCachedData(key);
              resolve(null);
            }
          } else {
            resolve(null);
          }
        };

        request.onerror = () => {
          reject(request.error);
        };
      });
    } catch (error) {
      console.error('Error getting cached data:', error);
      return null;
    }
  }

  private async setCachedData(key: string, data: any, cacheTime: any): Promise<void> {
    try {
      const db = await this.ensureDB();
      const transaction = db.transaction([this.storeName], 'readwrite');
      const store = transaction.objectStore(this.storeName);

      const expireTime = Date.now() + (parseFloat(cacheTime) * 1000);

      const cacheItem = {
        key,
        data,
        expireTime,
        createdAt: Date.now()
      };

      return new Promise((resolve, reject) => {
        const request = store.put(cacheItem);

        request.onsuccess = () => {
          resolve();
        };

        request.onerror = () => {
          reject(request.error);
        };
      });
    } catch (error) {
      console.error('Error setting cached data:', error);
    }
  }

  private async removeCachedData(key: string): Promise<void> {
    try {
      const db = await this.ensureDB();
      const transaction = db.transaction([this.storeName], 'readwrite');
      const store = transaction.objectStore(this.storeName);

      return new Promise((resolve, reject) => {
        const request = store.delete(key);

        request.onsuccess = () => {
          resolve();
        };

        request.onerror = () => {
          reject(request.error);
        };
      });
    } catch (error) {
      console.error('Error removing cached data:', error);
    }
  }

  private async cleanExpiredCache(): Promise<void> {
    try {
      const db = await this.ensureDB();
      const transaction = db.transaction([this.storeName], 'readwrite');
      const store = transaction.objectStore(this.storeName);
      const index = store.index('expireTime');

      const now = Date.now();
      const range = IDBKeyRange.upperBound(now);

      return new Promise((resolve, reject) => {
        const request = index.openCursor(range);

        request.onsuccess = (event: any) => {
          const cursor = event.target.result;
          if (cursor) {
            cursor.delete();
            cursor.continue();
          } else {
            resolve();
          }
        };

        request.onerror = () => {
          reject(request.error);
        };
      });
    } catch (error) {
      console.error('Error cleaning expired cache:', error);
    }
  }
  callApi(path: string, payload: any = null, options: any = null): Observable<any> {
    path = path.includes('batch') ? path : '/components' + path
    // Merge default options
    const defaultOptions = { cache: true, cacheTime: 10 }; // Default cache time is 10 seconds
    options = { ...defaultOptions, ...options };
    options.cache = false;
    // Chỉ cache cho GET requests (payload = null)
    if (options.cache) {
      const cacheKey = this.generateCacheKey(path, payload);
      return new Observable((observer) => {
        // Kiểm tra cache trước
        this.getCachedData(cacheKey).then((cachedData) => {
          if (cachedData) {
            // Trả về dữ liệu từ cache
            observer.next(cachedData);
            observer.complete();
            return;
          }

          // Không có cache, gọi API
          this.makeHttpRequest(path, payload).subscribe({
            next: (response) => {
              // Lưu vào cache nếu thành công
              if (response) {
                this.setCachedData(cacheKey, response, options.cacheTime);
              }
              observer.next(response);
              observer.complete();
            },
            error: (error) => {
              observer.error(error);
            }
          });
        }).catch((error) => {
          console.error('Cache error, falling back to direct API call:', error);
          // Lỗi cache, gọi API trực tiếp
          this.makeHttpRequest(path, payload).subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
            },
            error: (error) => {
              observer.error(error);
            }
          });
        });
      });
    } else {
      // Không cache, gọi API trực tiếp
      return this.makeHttpRequest(path, payload);
    }
  }

  private makeHttpRequest(path: string, payload: any): Observable<any> {
    console.log('path' + path)
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `ZSecure ${this.token}`
    };
    let request: any;
    request = payload ?
      this.http.post(`${this.env.apiUrl}${path}`, payload, { headers }) :
      this.http.get(`${this.env.apiUrl}${path}`, { headers });
    return request.pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.toast({
            title: this.translate.instant('session_expired'),
            message: this.translate.instant('session_expired_message'),
            type: 'danger',
          });
          localStorage.removeItem('user');
          localStorage.removeItem('token');
          window.location.href = "/guest/login";
        } else if (error.status === 403) {
          this.toast({
            title: this.translate.instant('permission_denied'),
            message: `${this.translate.instant(error.error?.code)}`,
            type: 'warning',
            delay: 10000
          });
        } else {
          this.toast({
            title: this.translate.instant('error'),
            message: `Lỗi hệ thống #${error.status}`,
            type: 'danger',

          });
        }
        return throwError(() => error);
      })
    );
  }

  // Cache management methods
  async clearCache(): Promise<void> {
    try {
      const db = await this.ensureDB();
      const transaction = db.transaction([this.storeName], 'readwrite');
      const store = transaction.objectStore(this.storeName);

      return new Promise((resolve, reject) => {
        const request = store.clear();

        request.onsuccess = () => {
          console.log('Cache cleared successfully');
          resolve();
        };

        request.onerror = () => {
          reject(request.error);
        };
      });
    } catch (error) {
      console.error('Error clearing cache:', error);
    }
  }

  async getCacheStats(): Promise<{ count: number, size: number }> {
    try {
      const db = await this.ensureDB();
      const transaction = db.transaction([this.storeName], 'readonly');
      const store = transaction.objectStore(this.storeName);

      return new Promise((resolve, reject) => {
        const request = store.getAll();

        request.onsuccess = () => {
          const items = request.result;
          const count = items.length;
          const size = JSON.stringify(items).length;
          resolve({ count, size });
        };

        request.onerror = () => {
          reject(request.error);
        };
      });
    } catch (error) {
      console.error('Error getting cache stats:', error);
      return { count: 0, size: 0 };
    }
  }

  // Auto cleanup expired cache every 5 minutes
  private startCacheCleanup(): void {
    setInterval(() => {
      this.cleanExpiredCache().catch(error => {
        console.error('Auto cache cleanup failed:', error);
      });
    }, 5 * 60 * 1000); // 5 minutes
  }

  get user() {
    try {
      return JSON.parse(localStorage.getItem('user') || 'null');
    } catch (e) {
      return null;
    }
  }
  get token() {
    try {
      return JSON.parse(localStorage.getItem('token') || 'null');
    } catch (e) {
      return null;
    }
  }
  get isLowTech() {
    let userAgent: any = window.navigator.userAgent;
    if (userAgent != null && userAgent != undefined) {
      let iOSVersion = userAgent.match(/iPhone OS (.*) like Mac OS X/)?.pop().split(/\D/).map((a: any) => parseInt(a)).shift();
      if (iOSVersion && iOSVersion < 16) {
        return true;
      }
    }
    return false;
  }
  modalControl(selector: string, action: boolean = true) {
    console.log('modalControl', this.modals[selector]);
    let element = document.querySelector(selector);
    if (!element) {
      console.error(`Modal element with selector "${selector}" not found.`);
      return;
    }
    this.modals[selector] = this.modals[selector] || new (window as any).bootstrap.Modal(element);
    // Thêm event Listener để xử lý khi modal được đóng
    element.addEventListener('hidden.bs.modal', () => {
      console.log(`Modal with selector "${selector}" has been closed.`);
      delete this.modals[selector];
    });
    if (action === false) {
      this.modals[selector].hide();
    } else {
      this.modals[selector].show();
    }
  }
  back() {
    this.location.back();
  }
  logout() {
    let oldToken = localStorage.getItem('oldToken') || '';
    let oldUser = localStorage.getItem('oldUser') || '{}';
    if (oldToken && oldUser) {
      localStorage.setItem('user', oldUser);
      localStorage.setItem('token', oldToken);
      localStorage.removeItem('oldUser');
      localStorage.removeItem('oldToken');
      this.router.navigate(['/']);
      return;
    }
    this.callApi(`/auth/logout`).subscribe({
      next: (res) => {
        if (res.success) {
          this.toast({
            title: this.translate.instant('toast_logout'),
            message: this.translate.instant('toast_logout_message'),
            type: 'info',
          });
          //xóa dữ liệu trong cache
          this.clearCache().then(() => {
            console.log('Cache cleared on logout');
          }).catch(error => {
            console.error('Error clearing cache on logout:', error);
          });
        }
      },
      complete: () => {
        // this.router.navigate(['/guest/login']);
        localStorage.clear();
        console.log('logout');
        setTimeout(() => {
          window.location.href = "/guest/login";
        }, 1500);
      }
    });
  }
  validateForm(form: FormGroup): void {
    console.log('validateForm', form.value);
    if (form.invalid) {
      // Nếu form không hợp lệ, thực hiện các hành động cần thiết như hiển thị thông báo lỗi
      this.toast({
        title: this.translate.instant('error'),
        message: this.translate.instant('form_invalid'),
        type: 'danger',
      });
      throw new Error('Form is invalid');
    }
  }
  sort(data: any[], key: string) {
    let type = !this.shareObject.sortType;
    this.shareObject.sortType = type;
    data.sort((a: any, b: any) => {
      if (key.includes('.')) {
        let keys = key.split('.');
        let aValue = keys.reduce((obj, k) => obj && obj[k], a);
        let bValue = keys.reduce((obj, k) => obj && obj[k], b);
        let isNumber = /^\d+$/.test(aValue) && /^\d+$/.test(bValue);
        if (!isNumber) {
          aValue = String(aValue).toLowerCase();
          bValue = String(bValue).toLowerCase();
        }
        if (type) {
          if (aValue < bValue) return -1;
          if (aValue > bValue) return 1;
        } else {
          if (aValue > bValue) return -1;
          if (aValue < bValue) return 1;
        }
      } else {
        if (type) {
          if (a[key] < b[key]) return -1;
          if (a[key] > b[key]) return 1;
        } else {
          if (a[key] > b[key]) return -1;
          if (a[key] < b[key]) return 1;
        }
      }
      return 0;
    });
  }
  async generatorQRCode(text: string) {
    try {
      // 1. Tạo QR code dưới dạng Data URL
      const qrDataUrl = await QRCode.toDataURL(text, { errorCorrectionLevel: 'H', width: 500, margin: 2 });

      // 2. Tạo canvas để vẽ QR + Logo
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d')!;
      const img = new Image();

      // 3. Load QR code
      let result = await new Promise((resolve, reject) => {
        img.onload = async () => {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          // 4. Load và chèn logo
          const logo = await this.loadImage('assets/logo.png');
          const logoSize = img.width * 0.15; // 15% kích thước QR

          // Resize logo
          const resizedLogo = await this.resizeImage(logo, logoSize, logoSize);
          // thêm background trắng cho logo
          ctx.fillStyle = 'white';
          ctx.fillRect((img.width - logoSize) / 2 - 5, (img.height - logoSize) / 2 - 5, logoSize + 10, logoSize + 10);

          // Vẽ logo vào giữa
          ctx.drawImage(
            resizedLogo,
            (img.width - logoSize) / 2,
            (img.height - logoSize) / 2,
            logoSize,
            logoSize
          );

          // 5. Tạo URL để hiển thị và tải xuống
          const finalDataUrl = canvas.toDataURL('image/png');
          let qrImage = this.sanitizer.bypassSecurityTrustUrl(finalDataUrl);
          let downloadUrl = this.sanitizer.bypassSecurityTrustUrl(finalDataUrl);
          resolve({
            qrImage,
            downloadUrl,
            text,
          });
        };

        img.src = qrDataUrl;
      });
      return result;
    } catch (err) {
      console.error('Lỗi:', err);
      return null;
    }
  }
  loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Xử lý CORS nếu cần
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }
  resizeImage(
    img: HTMLImageElement,
    width: number,
    height: number
  ): Promise<HTMLCanvasElement> {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(img, 0, 0, width, height);
    return Promise.resolve(canvas);
  }
  async loadModels() {
    if (this.shareObject.modelLoading) {
      return;
    }
    this.shareObject.modelLoading = true;
    try {
      await tf.ready();
      await faceapi.nets.tinyFaceDetector.loadFromUri('/assets/models');
      await faceapi.nets.faceLandmark68Net.loadFromUri('/assets/models');
      await faceapi.nets.faceRecognitionNet.loadFromUri('/assets/models');
      await faceapi.nets.ssdMobilenetv1.loadFromUri('/assets/models');
      this.shareObject.modelLoaded = true;
      console.log('face-api models loaded');
    } catch (error) {
      console.log(`face-api`, error);
    }
  }
  async checkModelLoaded(): Promise<boolean> {
    if (this.shareObject.modelLoaded && this.shareObject.modelLoaded === true) {
      return true;
    }
    await this.loadModels();
    await new Promise((s) => setTimeout(() => { s(true); }, 100));
    return this.checkModelLoaded();
  }
  async idScan(face: any = null) {
    await this.checkModelLoaded();
    return new Promise(async (resolve, reject) => {
      let el = document.createElement('div');
      el.style.cssText = 'position: fixed; top: 0; left: 0;width: 100vw; height: 100vh; z-index: 9999;background-color:rgb(163, 163, 163);';

      let videoEl = document.createElement('video');
      videoEl.style.cssText = 'width: 100vw; height: 100vh; transform: scaleX(-1); object-fit: cover;';
      videoEl.setAttribute('playsinline', 'true');
      videoEl.setAttribute('autoplay', 'true');

      el.appendChild(videoEl);
      document.body.appendChild(el);

      let img = document.createElement('img');
      img.src = 'assets/faceid.svg';
      img.style.cssText = 'position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);pointer-events: none;z-index: 9999;height: calc(100vh - 100px);';
      el.appendChild(img);

      let cameraType: 'user' | 'environment' = 'user';
      let cameraStream: MediaStream | null = null;
      let intervalId: any = null;
      let isScanning = true;

      const openCamera = async () => {
        try {
          if (cameraStream) {
            cameraStream.getTracks().forEach(track => track.stop());
          }
          cameraStream = await navigator.mediaDevices.getUserMedia({
            video: {
              width: { ideal: 1920 },
              height: { ideal: 1080 },
              facingMode: cameraType
            }
          });
          videoEl.srcObject = cameraStream;
        } catch (error: any) {
          console.error('Error accessing camera:', error);
          if (error.name === 'AbortError') {
            this.toast({
              title: this.translate.instant('camera_error'),
              message: this.translate.instant('message_camera_error'),
              type: 'danger'
            });
          } else if (error.name === 'NotAllowedError') {
            this.toast({
              title: this.translate.instant('camera_error'),
              message: this.translate.instant('message_camera_permission_denied'),
              type: 'danger'
            });
          }
          reject(error);
        }
      };

      await openCamera();

      let btnClose = document.createElement('button');
      btnClose.style.cssText = 'position: absolute;top: 10px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnClose.innerHTML = '<i class="bi bi-x-circle fs-1"></i>';
      btnClose.onclick = () => {
        isScanning = false;
        if (intervalId) clearInterval(intervalId);
        if (cameraStream) {
          cameraStream.getTracks().forEach(track => track.stop());
        }
        videoEl.srcObject = null;
        el.remove();
        resolve(null);
      };
      el.appendChild(btnClose);

      let btnSwitchCamera = document.createElement('button');
      btnSwitchCamera.style.cssText = 'position: absolute;top: 70px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnSwitchCamera.innerHTML = '<i class="bi bi-camera fs-1"></i>';
      btnSwitchCamera.onclick = async () => {
        cameraType = cameraType === 'environment' ? 'user' : 'environment';
        await openCamera();
      };
      el.appendChild(btnSwitchCamera);

      intervalId = setInterval(async () => {
        if (!isScanning || !videoEl.srcObject) return;

        try {
          const faceScan = await faceapi.detectSingleFace(videoEl).withFaceLandmarks().withFaceDescriptor();
          if (faceScan) {
            img.style.filter = `hue-rotate(${360 - Math.floor((faceScan.detection.score * 180) + 90)}deg)`;

            if (face && faceScan.detection.score >= 0.90) {
              let distance = faceapi.euclideanDistance(faceScan.descriptor, face);
              console.log('distance:', distance);
              if (distance < 0.35) {
                isScanning = false;
                clearInterval(intervalId);
                if (cameraStream) cameraStream.getTracks().forEach(track => track.stop());
                videoEl.srcObject = null;
                el.remove();
                resolve(true);
              }
            }

            if (!face && faceScan.detection.score >= 0.98) {
              isScanning = false;
              clearInterval(intervalId);
              if (cameraStream) cameraStream.getTracks().forEach(track => track.stop());
              videoEl.srcObject = null;
              el.remove();
              resolve(Object.values(faceScan.descriptor));
            }
          } else {
            img.style.filter = 'hue-rotate(290deg)';
          }
        } catch (err) {
          console.error('faceapi error:', err);
          // tránh lỗi crash nếu video đã bị hủy
        }

      }, 1000);
    });
  }
  async idScans(users: any = null) {
    await this.checkModelLoaded();
    users = users || [];
    if (users.length > 0) {
      users = users.map((user: any) => {
        return {
          id: user.employee.id,
          name: user.employee.profile.name,
          face: user.faceId || null
        };
      });
    }
    return new Promise(async (resolve, reject) => {
      let el = document.createElement('div');
      el.style.cssText = 'position: fixed; top: 0; left: 0;width: 100vw; height: 100vh; z-index: 9999;background-color:rgb(163, 163, 163);';
      let videoEl = document.createElement('video');
      videoEl.style.cssText = 'width: 100vw; height: 100vh; transform: scaleX(-1); object-fit: cover;';
      videoEl.setAttribute('playsinline', 'true');
      videoEl.setAttribute('autoplay', 'true');
      el.appendChild(videoEl);
      document.body.appendChild(el);
      // videoEl.srcObject = await navigator.mediaDevices.getUserMedia({
      //   video: {
      //     width: { ideal: 1920 },
      //     height: { ideal: 1080 }
      //   }
      // });
      try {
        videoEl.srcObject = await navigator.mediaDevices.getUserMedia({
          video: {
            width: { ideal: 1920 },
            height: { ideal: 1080 }
          }
        });
      } catch (error: any) {
        console.error('Error accessing camera:', error);
        if (error.name === 'AbortError') {
          this.toast({
            title: this.translate.instant('camera_error'),
            message: this.translate.instant('message_camera_error'),
            type: 'danger'
          });
        } else if (error.name === 'NotAllowedError') {
          this.toast({
            title: this.translate.instant('camera_error'),
            message: this.translate.instant('message_camera_permission_denied'),
            type: 'danger'
          });
        }
      }
      let btnClose = document.createElement('button');
      btnClose.style.cssText = 'position: absolute;top: 10px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnClose.innerHTML = '<i class="bi bi-x-circle fs-1"></i>';
      btnClose.onclick = () => {
        videoEl.srcObject = null;
        videoEl.src = '';
        document.body.removeChild(el);
        resolve(null);
      };
      el.appendChild(btnClose);
      let btnSwitchCamera = document.createElement('button');
      btnSwitchCamera.style.cssText = 'position: absolute;top: 70px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnSwitchCamera.innerHTML = '<i class="bi bi-camera fs-1"></i>';
      let cameraType = 'environment';
      btnSwitchCamera.onclick = () => {
        let stream = videoEl.srcObject as MediaStream;
        if (stream) {
          stream.getTracks().forEach(track => track.stop());
        }
        videoEl.srcObject = null;
        videoEl.src = '';
        cameraType = cameraType === 'environment' ? 'user' : 'environment';
        navigator.mediaDevices.getUserMedia({ video: { facingMode: cameraType } }).then((stream) => {
          videoEl.srcObject = stream;
        });
      };
      el.appendChild(btnSwitchCamera);



      let labels = document.createElement('div');
      labels.style.cssText = 'position: fixed;top: 10px;left: 10px;z-index: 9999;pointer-events: none;';
      labels.id = 'face-id-labels';
      el.appendChild(labels);
      let countTime = 0;
      let intval = setInterval(async () => {
        countTime += 0.5;
        let faces = await faceapi.detectAllFaces(videoEl).withFaceLandmarks().withFaceDescriptors();
        if (faces) {
          for (let i = 0; i < users.length; i++) {
            let user = users[i];
            for (let j = 0; j < faces.length; j++) {
              let face = faces[j];
              console.log('face', user.name, face.detection.score);
              if (face.detection.score >= 0.95) {
                let distance = faceapi.euclideanDistance(face.descriptor, user.face);
                console.log('distance', user.name, distance);

                if (distance < 0.35) {
                  let label: any = labels.querySelector(`#face-id-label-${user.id}`);
                  console.log('countTime:', countTime);
                  // if (user.countTime && countTime - user.countTime >= 30) {
                  //   console.log(user.countTime, countTime);
                  //   label.style.cssText = 'background-color: rgba(255, 255, 255, 0.8);padding: 5px 15px;border-radius: 5px;z-index: 9999; margin-bottom: 5px;pointer-events: auto;cursor: pointer;';
                  // }
                  if (!label && (!user.countTime || (user.countTime && countTime - user.countTime >= 30))) {
                    label = document.createElement('div');
                    label.style.cssText = 'background-color: rgba(255, 255, 255, 0.8);padding: 5px 15px;border-radius: 5px;z-index: 9999; margin-bottom: 5px;pointer-events: auto;cursor: pointer;';
                    label.id = `face-id-label-${user.id}`;
                    labels.appendChild(label);
                    label.onclick = () => {
                      label.style.backgroundColor = 'rgba(32, 202, 89, 0.5)';
                      label.style.color = 'rgb(255, 255, 255)';
                      this.callApi('/employee_attendance/attendance_from_station', { userId: user.id }).subscribe({
                        next: (res: any) => {
                          if (res.success) {
                            this.toast({
                              title: this.translate.instant('attendance_success'),
                              message: `${user.name} ${this.translate.instant('attendance_success_message')}`,
                              type: 'success'
                            });
                            user.countTime = countTime;
                            label.style.pointerEvents = 'none';
                            label.style.backgroundColor = 'rgba(4, 48, 19, 0.5)';
                            label.style.color = 'rgb(255, 255, 255)';
                            //remove label after 5 seconds
                            setTimeout(() => {
                              labels.removeChild(label);
                            }, 5000);
                          } else {
                            this.toast({
                              title: this.translate.instant('attendance_failed'),
                              message: `${user.name} ${this.translate.instant('attendance_failed_message')}`,
                              type: 'danger'
                            });
                          }
                        },
                        error: (err) => {
                          this.toast({
                            title: this.translate.instant('attendance_failed'),
                            message: `${user.name} ${this.translate.instant('attendance_failed_message')}`,
                            type: 'danger'
                          });
                        }
                      });
                    }
                  }
                  // label.innerHTML = `Điểm danh ${user.name}`;
                  label.innerHTML = `${this.translate.instant('attendance_for_user')} ${user.name}`;
                }
              }
            }
          }
        } else {
          console.log('No face detected');
        }
      }, 500);
    })
  }
  async qrScan() {
    return new Promise((resolve, reject) => {
      let el = document.createElement('div');
      el.style.cssText = 'position: fixed; top: 0; left: 0;width: 100vw; height: 100vh; z-index: 9999;background-color:rgb(163, 163, 163);';
      let videoEl = document.createElement('video');
      videoEl.style.cssText = 'width: 100vw; height: 100vh; transform: scaleX(-1); object-fit: cover;';
      videoEl.setAttribute('playsinline', 'true');
      videoEl.setAttribute('autoplay', 'true');
      el.appendChild(videoEl);
      document.body.appendChild(el);
      let qrScanner = new QrScanner(
        videoEl,
        (result: any) => {
          if (result) {
            qrScanner.stop();
            qrScanner.destroy();
            document.body.removeChild(el);
            resolve(result.data);
          }
        },
        {
          highlightScanRegion: true,
          highlightCodeOutline: true,
        }
      );
      qrScanner.start();

      let btnClose = document.createElement('button');
      btnClose.style.cssText = 'position: absolute;top: 10px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnClose.innerHTML = '<i class="bi bi-x-circle fs-1"></i>';
      btnClose.onclick = () => {
        qrScanner.stop();
        qrScanner.destroy();
        document.body.removeChild(el);
        resolve(false);
      };
      el.appendChild(btnClose);
      let btnSwitchCamera = document.createElement('button');
      btnSwitchCamera.style.cssText = 'position: absolute;top: 70px;right: 10px;z-index: 9999;background-color: #ba6aef00;color: #d19119;border: none;padding: 10px;cursor: pointer;width: 60px;height: 60px;display: flex;justify-content: center;align-items: center;border-radius: 50%;';
      btnSwitchCamera.innerHTML = '<i class="bi bi-camera fs-1"></i>';
      let cameraType = 'environment';
      btnSwitchCamera.onclick = () => {
        cameraType = cameraType === 'environment' ? 'user' : 'environment';
        qrScanner.setCamera(cameraType);
      };
      el.appendChild(btnSwitchCamera);

    });
  }
  timekeepingTypeText(type: any) {
    let typeText = this.env.timekeepingTypes.find((t: any) => t.value === type)?.name || this.translate.instant('unknown');
    return typeText;
  }
  shippingStatusText(status: any) {
    let e = { status: status, statusText: '', statusClass: '' };
    switch (e.status) {
      case this.env.constants.LOCALSHIPPING.STATUS.PENDING:
        e.statusText = this.translate.instant('status_pending');
        e.statusClass = 'bg-warning';
        break;
      case this.env.constants.LOCALSHIPPING.STATUS.DRIVER_CONFIRM:
        e.statusText = this.translate.instant('status_driver_confirm');
        e.statusClass = 'bg-primary';
        break;
      case this.env.constants.LOCALSHIPPING.STATUS.PICKUP:
        e.statusText = this.translate.instant('status_pickup');
        e.statusClass = 'bg-info';
        break;
      case this.env.constants.LOCALSHIPPING.STATUS.DELIVERING:
        e.statusText = this.translate.instant('status_delivering');
        e.statusClass = 'bg-info';
        break;
      case this.env.constants.LOCALSHIPPING.STATUS.DELIVERED:
        e.statusText = this.translate.instant('status_delivered');
        e.statusClass = 'bg-success';
        break;
      case this.env.constants.LOCALSHIPPING.STATUS.DELAYED:
        e.statusText = this.translate.instant('status_delayed');
        e.statusClass = 'bg-warning';
        break;
      case this.env.constants.LOCALSHIPPING.STATUS.CANCELLED:
        e.statusText = this.translate.instant('status_cancelled');
        e.statusClass = 'bg-danger';
        break;
      case this.env.constants.LOCALSHIPPING.STATUS.RETURNED:
        e.statusText = this.translate.instant('status_returned');
        e.statusClass = 'bg-danger';
        break;
      default:
        e.statusText = this.translate.instant('status_unknown');
        e.statusClass = 'bg-secondary';
        break;
    }
    return e;
  }
  productRequestStatusText(status: any) {
    let e = { status: status, statusText: '', statusClass: '' };
    switch (e.status) {
      case this.env.constants.PRODUCT_REQUEST_STATUS.PENDING:
        e.statusText = this.translate.instant('status_pending');
        e.statusClass = 'bg-warning';
        break;
      case this.env.constants.PRODUCT_REQUEST_STATUS.PROCESSING:
        e.statusText = this.translate.instant('status_processing');
        e.statusClass = 'bg-primary';
        break;
      case this.env.constants.PRODUCT_REQUEST_STATUS.COMPLETED:
        e.statusText = this.translate.instant('status_completed');
        e.statusClass = 'bg-info';
        break;
      case this.env.constants.PRODUCT_REQUEST_STATUS.REJECTED:
        e.statusText = this.translate.instant('status_rejected');
        e.statusClass = 'bg-info';
        break;
      case this.env.constants.PRODUCT_REQUEST_STATUS.CANCELED:
        e.statusText = this.translate.instant('status_canceled');
        e.statusClass = 'bg-success';
        break;
      default:
        e.statusText = this.translate.instant('status_unknown');
        e.statusClass = 'bg-secondary';
        break;
    }
    return e;
  }
  defineForm(formFields: any) {
    let filter = {
      ...formFields
        .filter((field: any) => field.filter)
        .reduce((acc: any, field: any) => {
          acc[field.field] = {
            filter: field.filter,
            type: field.type || null,
            subType: field.subType || null,
            getValue: field?.getValue
          };
          return acc;
        }, {})
    };

    let formHandle = formFields.reduce((acc: any, field: any) => {
      acc[field.field] = [field.default ?? '', field.valid || []];
      return acc;
    }, {});

    let filterForm = {
      ...Object.fromEntries(formFields.map((field: any) => [field.field, field.default ?? '']))
    };
    return { filter, formHandle, filterForm };
  }
  translateKeyword() {
    //Day of week
    this.translate.instant('monday');
    this.translate.instant('tuesday');
    this.translate.instant('wednesday');
    this.translate.instant('thursday');
    this.translate.instant('friday');
    this.translate.instant('saturday');
    this.translate.instant('sunday');
    this.translate.instant('timekeeping_hour');
    this.translate.instant('timekeeping_day');
    this.translate.instant('timekeeping_kpi');
    this.translate.instant('timekeeping_none');
    this.translate.instant('timekeeping_type_month');
    this.translate.instant('timekeeping_type_hour_kpi');
    this.translate.instant('timekeeping_type_day_kpi');
    this.translate.instant('timekeeping_type_month_kpi');
  }
  copyText(text: string) {
    let textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed'; // Prevent scrolling to bottom of page in MS Edge.
    textArea.style.opacity = '0'; // Make it invisible
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Failed to copy text:', err);
    } finally {
      document.body.removeChild(textArea);
    }
  }
  // write function to get location of user

}


